import React, { useEffect, useState } from "react";
import ProgressBar from "react-bootstrap/ProgressBar";
import {
  getAprrovingValue,
  buy,
  buyWithETH,
  USDTapprove,
  USDCapprove,
  getTxn,
  GettingETHValue,
  getSaleInfo,
} from "./Methods";
import { formatUnits } from "viem";
import { parseEther } from "viem";
import { useAccount, useConnect, useDisconnect, useWalletClient } from "wagmi";
import "./Calculator.css";

const Calculator = () => {
  const options = [
    {
      label: "ETH",
      value: "0",
      image: "/images/eth.png",
    },
    {
      label: "USDT",
      value: "1",
      image: "/images/usdt-removebg-preview.png",
    },
    {
      label: "USDC",
      value: "2",
      image: "/images/invest1.png",
    },
  ];

  const user = useAccount();
  const [selectedOption, setSelectedOption] = useState(options[0]);
  const [Total, setTotal] = useState("");
  const [sold, setSold] = useState("");
  const [price, setprice] = useState("");
  const [pay, setPay] = useState("0");
  const [value, setValue] = useState("0");
  const [calculatedVAl, setCalculatedVal] = useState("");
  const [Loader, setLoader] = useState(false);

  useEffect(() => {
    fetchSaleInfo();
    totalCheck();
    setCalculatedVal("");
  }, []);

  const totalCheck = () => {
    if (sold <= 400) {
      setTotal("400");
    } else {
      setTotal("1000");
    }
  };

  const fetchSaleInfo = async () => {
    const x = await getSaleInfo();
    console.log("value of x", x);

    if (typeof x[0] === "bigint") {
      setSold(Number(x[1]));
    } else {
      setSold(x[1]);
    }
    if (typeof x[0] === "bigint") {
      setprice(Number(x[0]));
    } else {
      setprice(x[0]);
    }
  };

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setPay(option.value);
    setCalculatedVal("");
    setValue("");
  };

  const handleChange = (e) => {
    e.preventDefault();
    const inputValue = e.target.value;

    if (inputValue === "" || (/^\d+$/.test(inputValue) && parseInt(inputValue, 10) <= 400)) {
      setValue(inputValue);
    }
  };

  const handleBuying = async () => {
    setLoader(true);
    try {
      if (pay === "1" || pay === "2") {
        if (pay === "2") {
          try {
            console.log("VAlue in usdc", value);
            let data = await getAprrovingValue(value);
            let x = await USDCapprove(data);
            const receipt = await getTxn(x);
            if (!receipt) {
              console.log("USDC not approve");
            }
            try {
              let x = await buy(value, pay);
              const receipt = await getTxn(x);
              if (!receipt) {
                console.log("Error while buying pocket from usdc");
              }
            } catch (error) {
              console.log(error);
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          const calculatedVAlue = value * 1000000;
          try {
            let data = await getAprrovingValue(value);
            let x = await USDTapprove(data);
            const receipt = await getTxn(x);
            if (!receipt) {
              console.log("USDT not APPROVE");
            }
            try {
              let x = await buy(value, pay);
              const receipt = await getTxn(x);
              if (!receipt) {
                console.log("error while buying pocket from usdt");
              }
            } catch (error) {
              console.log(error);
            }
          } catch (error) {
            console.log(error);
          }
        }
      }

      if (pay === "0") {
        let data = await GettingETHValue(value);
        console.log("data from backend", data);
        let ethValue = formatUnits(data, 18);
        console.log("KAshif is a good boy", ethValue, value);
        let x = await buyWithETH(value, ethValue);
        console.log("buyWithETH", x);
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  return (
    <>
      <div className="calculator">
        <div className="content">
          <h2>$Pocket Pre-Sale</h2>
          <div className="progress">
            <span>
              {sold / 100}/{Total} $POCKET
            </span>
            <ProgressBar now={sold / 100} max={Total} />
          </div>
          <div className="launch-price">
            <h4>
              Current PreSale Price = <span>${price / 1000000}</span>
            </h4>
          </div>
          <form className="calculateform">
            <div className="form-group">
              <div className="form-heading">
                <label>Select Payment Method</label>
              </div>
              <div className="payment-buttons">
                {options.map((option) => (
                  <button
                    key={option.label}
                    type="button"
                    className={`payment-button ${selectedOption.value === option.value ? 'active' : ''}`}
                    onClick={() => handleOptionClick(option)}
                  >
                    <img src={option.image} alt={option.label} />
                    <span>{option.label}</span>
                  </button>
                ))}
              </div>
              <div className="form-heading mt-3">
                <label>Pocket to buy</label>
              </div>
              <div className="form">
                <div className="input-with-icon">
                  <img src="/images/logo.png" alt="POCKET" className="input-icon" />
                  <input
                    maxLength={10}
                    onChange={handleChange}
                    value={value}
                    type="text"
                    className="form-control"
                    placeholder="Enter Amount to buy"
                  />
                </div>
              </div>
            </div>
            <div className="calculate-btn">
              <button
                type="button"
                className="btn form-control"
                disabled={Loader}
                onClick={handleBuying}
              >
                Buy $POCKET
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Calculator;
